<svg
    viewBox="0 0 19 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    id="el_puoVK7a54"
    class="hearts"
    ><style>
        @-webkit-keyframes kf_el_jRFP1iZ8mU_an_S_lfJ5nY9Q {
            0% {
                opacity: 0;
            }
            24.17% {
                opacity: 1;
            }
            40% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @keyframes kf_el_jRFP1iZ8mU_an_S_lfJ5nY9Q {
            0% {
                opacity: 0;
            }
            24.17% {
                opacity: 1;
            }
            40% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @-webkit-keyframes kf_el_jRFP1iZ8mU_an_-l8DO8tko {
            0% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            25% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            50% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            100% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
        }
        @keyframes kf_el_jRFP1iZ8mU_an_-l8DO8tko {
            0% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            25% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            50% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
            100% {
                -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
                transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            }
        }
        @-webkit-keyframes kf_el_jRFP1iZ8mU_an_DgJ-5qTdj {
            0% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
            }
            50% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
            }
            100% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
            }
        }
        @keyframes kf_el_jRFP1iZ8mU_an_DgJ-5qTdj {
            0% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
            }
            50% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
            }
            100% {
                -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
                transform: translate(0px, 10px) translate(0px, -10px) translate(0px, -20px);
            }
        }
        @-webkit-keyframes kf_el_7PCBmmds0c_an_0wJgoJVV- {
            36.67% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            75% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            0% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            100% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
        }
        @keyframes kf_el_7PCBmmds0c_an_0wJgoJVV- {
            36.67% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            75% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            0% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
            100% {
                -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
                transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            }
        }
        @-webkit-keyframes kf_el_7PCBmmds0c_an_p3yGQ4dJWc {
            36.67% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            }
            100% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, -20px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, -20px);
            }
            0% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            }
        }
        @keyframes kf_el_7PCBmmds0c_an_p3yGQ4dJWc {
            36.67% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            }
            100% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, -20px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, -20px);
            }
            0% {
                -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
                transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            }
        }
        @-webkit-keyframes kf_el_7PCBmmds0c_an_q1GKtUIDS {
            36.67% {
                opacity: 0;
            }
            72.50% {
                opacity: 1;
            }
            90% {
                opacity: 0;
            }
            0% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @keyframes kf_el_7PCBmmds0c_an_q1GKtUIDS {
            36.67% {
                opacity: 0;
            }
            72.50% {
                opacity: 1;
            }
            90% {
                opacity: 0;
            }
            0% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @-webkit-keyframes kf_el_bOn6_Lkvw0_an_Ov13I5_KK {
            30.83% {
                opacity: 0;
            }
            55.00% {
                opacity: 1;
            }
            70.83% {
                opacity: 0;
            }
            0% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @keyframes kf_el_bOn6_Lkvw0_an_Ov13I5_KK {
            30.83% {
                opacity: 0;
            }
            55.00% {
                opacity: 1;
            }
            70.83% {
                opacity: 0;
            }
            0% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }
        @-webkit-keyframes kf_el_bOn6_Lkvw0_an_NB5bG0XGUT {
            30.83% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            }
            80.83% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
            }
            0% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            }
            100% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
            }
        }
        @keyframes kf_el_bOn6_Lkvw0_an_NB5bG0XGUT {
            30.83% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            }
            80.83% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
            }
            0% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            }
            100% {
                -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
                transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, -20px);
            }
        }
        @-webkit-keyframes kf_el_bOn6_Lkvw0_an_rE0dVlV53 {
            30.83% {
                -webkit-transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            }
            55.00% {
                -webkit-transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
            }
            0% {
                -webkit-transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            }
            100% {
                -webkit-transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
            }
        }
        @keyframes kf_el_bOn6_Lkvw0_an_rE0dVlV53 {
            30.83% {
                -webkit-transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            }
            55.00% {
                -webkit-transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
            }
            0% {
                -webkit-transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            }
            100% {
                -webkit-transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
                transform: translate(3px, 0px) scale(1.6, 1.6) translate(-3px, 0px);
            }
        }
        #el_puoVK7a54 * {
            -webkit-animation-duration: 4s;
            animation-duration: 4s;
            -webkit-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_IIytet5NQt {
            stroke: none;
            stroke-width: 1;
            fill: none;
        }
        #el_jRFP1iZ8mU {
            fill: #f57467;
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            opacity: 0;
            -webkit-animation-name: kf_el_jRFP1iZ8mU_an_S_lfJ5nY9Q;
            animation-name: kf_el_jRFP1iZ8mU_an_S_lfJ5nY9Q;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_7PCBmmds0c {
            fill: #679ef5;
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            opacity: 0;
            -webkit-animation-name: kf_el_7PCBmmds0c_an_q1GKtUIDS;
            animation-name: kf_el_7PCBmmds0c_an_q1GKtUIDS;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_bOn6_Lkvw0 {
            fill: #f5e167;
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            opacity: 0;
            -webkit-animation-name: kf_el_bOn6_Lkvw0_an_Ov13I5_KK;
            animation-name: kf_el_bOn6_Lkvw0_an_Ov13I5_KK;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_bOn6_Lkvw0_an_rE0dVlV53 {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            transform: translate(3px, 0px) scale(1, 1) translate(-3px, 0px);
            -webkit-animation-name: kf_el_bOn6_Lkvw0_an_rE0dVlV53;
            animation-name: kf_el_bOn6_Lkvw0_an_rE0dVlV53;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_bOn6_Lkvw0_an_NB5bG0XGUT {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            transform: translate(3px, 0px) translate(-3px, 0px) translate(0px, 30px);
            -webkit-animation-name: kf_el_bOn6_Lkvw0_an_NB5bG0XGUT;
            animation-name: kf_el_bOn6_Lkvw0_an_NB5bG0XGUT;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_7PCBmmds0c_an_p3yGQ4dJWc {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            transform: translate(12px, 5px) translate(-12px, -5px) translate(0px, 30px);
            -webkit-animation-name: kf_el_7PCBmmds0c_an_p3yGQ4dJWc;
            animation-name: kf_el_7PCBmmds0c_an_p3yGQ4dJWc;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_7PCBmmds0c_an_0wJgoJVV- {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            transform: translate(12px, 5px) scale(1, 1) translate(-12px, -5px);
            -webkit-animation-name: kf_el_7PCBmmds0c_an_0wJgoJVV-;
            animation-name: kf_el_7PCBmmds0c_an_0wJgoJVV-;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_jRFP1iZ8mU_an_DgJ-5qTdj {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
            transform: translate(0px, 10px) translate(0px, -10px) translate(0px, 30px);
            -webkit-animation-name: kf_el_jRFP1iZ8mU_an_DgJ-5qTdj;
            animation-name: kf_el_jRFP1iZ8mU_an_DgJ-5qTdj;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
        #el_jRFP1iZ8mU_an_-l8DO8tko {
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            -webkit-transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            transform: translate(0px, 10px) scale(1, 1) translate(0px, -10px);
            -webkit-animation-name: kf_el_jRFP1iZ8mU_an_-l8DO8tko;
            animation-name: kf_el_jRFP1iZ8mU_an_-l8DO8tko;
            -webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);
            animation-timing-function: cubic-bezier(0, 0, 1, 1);
        }
    </style>
    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <g id="el_IIytet5NQt" fill-rule="evenodd">
        <g id="el_UbH5tdyPMI">
            <g id="el_jRFP1iZ8mU_an_DgJ-5qTdj" data-animator-group="true" data-animator-type="0">
                <g
                    id="el_jRFP1iZ8mU_an_-l8DO8tko"
                    data-animator-group="true"
                    data-animator-type="2"
                >
                    <path
                        d="M3.8475,17.4245232 C1.53,15.3885559 0,14.0457766 0,12.3978202 C0,11.0550409 1.089,10 2.475,10 C3.258,10 4.0095,10.3531335 4.5,10.9111717 C4.9905,10.3531335 5.742,10 6.525,10 C7.911,10 9,11.0550409 9,12.3978202 C9,14.0457766 7.47,15.3885559 5.1525,17.4288828 L4.5,18 L3.8475,17.4245232 Z"
                        id="el_jRFP1iZ8mU"
                    />
                </g>
            </g>
            <g id="el_7PCBmmds0c_an_p3yGQ4dJWc" data-animator-group="true" data-animator-type="0">
                <g
                    id="el_7PCBmmds0c_an_0wJgoJVV-"
                    data-animator-group="true"
                    data-animator-type="2"
                >
                    <path
                        d="M14.885625,10.5683924 C13.1475,9.04141689 12,8.03433243 12,6.79836512 C12,5.79128065 12.81675,5 13.85625,5 C14.4435,5 15.007125,5.26485014 15.375,5.68337875 C15.742875,5.26485014 16.3065,5 16.89375,5 C17.93325,5 18.75,5.79128065 18.75,6.79836512 C18.75,8.03433243 17.6025,9.04141689 15.864375,10.5716621 L15.375,11 L14.885625,10.5683924 Z"
                        id="el_7PCBmmds0c"
                    />
                </g>
            </g>
            <g id="el_bOn6_Lkvw0_an_NB5bG0XGUT" data-animator-group="true" data-animator-type="0">
                <g
                    id="el_bOn6_Lkvw0_an_rE0dVlV53"
                    data-animator-group="true"
                    data-animator-type="2"
                >
                    <path
                        d="M4.92375,3.71226158 C3.765,2.69427793 3,2.02288828 3,1.19891008 C3,0.527520436 3.5445,0 4.2375,0 C4.629,0 5.00475,0.176566757 5.25,0.455585831 C5.49525,0.176566757 5.871,0 6.2625,0 C6.9555,0 7.5,0.527520436 7.5,1.19891008 C7.5,2.02288828 6.735,2.69427793 5.57625,3.71444142 L5.25,4 L4.92375,3.71226158 Z"
                        id="el_bOn6_Lkvw0"
                    />
                </g>
            </g>
        </g>
    </g>
</svg>

<style>
    .hearts {
        position: absolute;
        width: 20px;
        bottom: 30px;
        height: 40px;
    }
</style>
